export default __webpack_public_path__ + "static/metallocherepica-e6f9b6aae4b3d7df56e7c9069958cbfd.jpg";